import React from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { CircleNotch } from "@phosphor-icons/react";
import api from "@/lib/api";

const LABEL = { primary_guest_name: "Ime", primary_guest_email: "Email", primary_guest_phone: "Telefon" };
const d = (iso) => (iso ? new Date(iso).toLocaleDateString("hr-HR") : "");

// After a guest edit: asks whether to also update open reservations that still show the old data.
export function GuestSyncDialog({ guestId, items, onDone }) {
  const [picked, setPicked] = React.useState(() => new Set(items.map((r) => r.id)));
  const [busy, setBusy] = React.useState(false);
  const toggle = (id) => setPicked((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const apply = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/guests/${guestId}/sync-reservations`, { reservation_ids: [...picked] });
      toast.success(`Ažurirano rezervacija: ${data.updated}`);
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Ažuriranje nije uspjelo");
    } finally { setBusy(false); }
  };
  return createPortal(
    <div className="rw-modal-overlay z-[90]" data-testid="guest-sync-dialog">
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-5 shadow-2xl">
        <h3 className="text-base font-semibold text-foreground">Ažurirati i otvorene rezervacije?</h3>
        <p className="mt-1 text-xs text-muted-foreground">Ove rezervacije još prikazuju stare podatke gosta. Izdani računi se ne mijenjaju.</p>
        <div className="mt-3 max-h-64 space-y-2 overflow-y-auto">
          {items.map((r) => (
            <label key={r.id} className="flex cursor-pointer items-start gap-2 rounded-md border border-border px-3 py-2 text-xs" data-testid={`guest-sync-res-${r.id}`}>
              <input type="checkbox" checked={picked.has(r.id)} onChange={() => toggle(r.id)} className="mt-0.5 h-4 w-4" />
              <span>
                <span className="block font-semibold text-foreground">{r.unit_name || "Rezervacija"} · {d(r.check_in)} – {d(r.check_out)}</span>
                <span className="text-muted-foreground">{Object.entries(r.changes).map(([k, v]) => `${LABEL[k] || k}: ${v}`).join(" · ")}</span>
              </span>
            </label>
          ))}
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onDone} className="rw-btn-secondary rw-btn-sm" data-testid="guest-sync-skip">Ne, samo gost</button>
          <button onClick={apply} disabled={busy || picked.size === 0} className="rw-btn-primary rw-btn-sm" data-testid="guest-sync-apply">
            {busy && <CircleNotch size={12} className="animate-spin" />} Ažuriraj odabrane
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
